import './breadcrumb.scss'
import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import routes from '../../routes';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';

const Breadcrumb = ({ extraItem, currentItem, firstItem, style }) => {
	const location = useLocation();

	// تجزیه مسیر فعلی برای ایجاد مسیرهای بردکرامب
	const pathParts = location.pathname.split('/').filter(Boolean);

	let breadcrumbItems = [];

	if (firstItem) {
		pathParts[0] = firstItem.path;
		breadcrumbItems.push(firstItem);
	}
	// else {
	// 	// اگر firstItem پاس داده نشده باشد، مسیر اصلی (خانه) را اضافه می‌کنیم
	// 	breadcrumbItems.push({ label: 'خانه', path: '/' });
	// }

	// یافتن مسیرهای بردکرامب از routes
	breadcrumbItems = breadcrumbItems.concat(pathParts.map((_, index) => {
		const path = `/${pathParts.slice(0, index + 1).join('/')}`;
		const route = routes.find(route => route.path === path || route.path.startsWith(`${path}/`));
		return route ? { label: route.title, path } : null;
	}).filter(Boolean));

	// افزودن آیتم اضافی (مثل دسته‌بندی)
	if (extraItem) {
		breadcrumbItems.push(extraItem);
	}

	// افزودن آیتم جاری (مثل نام فیلم یا سریال)
	if (currentItem) {
		breadcrumbItems.push({ label: currentItem });
	}

	return (
		<nav className="breadcrumb-container" aria-label="breadcrumb" style={style}>
			<ul className="breadcrumb-list">
				{breadcrumbItems.map((item, index) => (
					<li key={index} className="breadcrumb-item">
						{index !== breadcrumbItems.length - 1 ? (
							<>
								<Link to={item.path} className="breadcrumb-link">
									{item.label}
								</Link>
								<span className="breadcrumb-separator"> <NavigateBeforeIcon/> </span>
							</>
						) : (
							<span className="breadcrumb-current">{item.label}</span>
						)}
					</li>
				))}
			</ul>
		</nav>
	);
};

export default Breadcrumb;
